import React, { useState, useEffect, Link } from "react";
import AudioPlayer from './AudioPlayer';
import { useSelector, useDispatch } from 'react-redux';
import { alert_error, alert_success } from "../../../AppContext.js";
import { update_api_response } from '../../../order/orders/actions.js';
import { Cookies } from '../../../index.js';
import Login_google from '../../../kiemtien/urlshorten/login.jsx';
import Language_i18 from '../../../js/useNationalLanguage.jsx';

function Ordergoogle({ }) {
    const [apikey, set_apikey] = useState('');
    const [show_login, set_show_login] = useState('');
    const { lang } = Language_i18();

    const translations = {
        vi: {
            copied: "Đã sao chép",
            continueGoogle: "Tiếp tục google miễn phí không giới hạn",
            transferInfo: "Thông Tin chuyển",
            copy: "Sao Chép",
        },
        en: {
            copied: "Copied",
            continueGoogle: "Continue with Google for free (unlimited)",
            transferInfo: "Converted Info",
            copy: "Copy",
        }
    };

    const api_response = useSelector(state => state.api_response);
    const latest_version = useSelector(state => state.latest_version);

    const dispatch = useDispatch();

    const set_api_response = (value) => {
        dispatch(update_api_response(value));
    };
    const resetok = () => {
        set_api_response('');
    }
    const services_orders = useSelector(state => state.services_orders);
    function saochep(value) {
        alert_success(translations[lang]?.copied || translations.vi.copied);
        window.saochepnative(value);
    };
    useEffect(() => {
        const apikey = Cookies.get('apikey');
        set_apikey(apikey);
        const lienket = window.location.href;
        Cookies.set('hustmediavipro', lienket, { expires: 1 / 12 });
    }, []);
    return (
        <> {!apikey && latest_version != 2 && (<>
            <div className="mb-1 ">
                <button onClick={() => set_show_login(!show_login)}>{translations[lang]?.continueGoogle || translations.vi.continueGoogle} <input
                    type="checkbox"
                    checked={show_login}
                    onChange={() => set_show_login(!show_login)}
                    className="mr-2"
                /></button>
                <div>
                    {
                        show_login && (<>
                            <Login_google />
                        </>)
                    }
                </div>
            </div>
        </>)}
            {services_orders && services_orders.type && services_orders.category.includes("text_speech") && (
                <>
                    {
                        api_response.voice && (
                            <>
                                <AudioPlayer src={api_response.voice} onReset={resetok} />
                            </>
                        )
                    } </>
            )}
            {api_response && (
                <>
                    {
                        api_response.text_vip && (
                            <>
	                                <div className="mt-2 mb-1  relative py-3 sm:max-w-xl sm:mx-auto bg-gray-100 p-2 rounded-md shadow-md">
	                                    <div className="flex items-center">
	                                        <h3 className="text-lg font-semibold mb-2 ml-2">{translations[lang]?.transferInfo || translations.vi.transferInfo}</h3>
	                                        <div className="ml-auto">
	                                            <button
	                                                onClick={() => saochep(api_response.text_vip)}
	                                                className="px-3 py-1 bg-blue-200 text-black text-base rounded-md hover:bg-blue-300 focus:outline-none focus:ring focus:border-blue-300"
	                                            >
	                                                {translations[lang]?.copy || translations.vi.copy}
	                                            </button>
	                                        </div>
	                                    </div>
                                    <div className="flex items-center mb-0">
                                        <div className="ml-4">
                                            <div
                                                className="font-bold text-base text-gray-600"
                                                dangerouslySetInnerHTML={{ __html: api_response.text_vip }}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </>
                        )
                    } </>
            )}

        </>
    );
}

export default Ordergoogle;
